import React, { useState, useContext, useEffect, useMemo, useRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import StyledButton from "../StyledButton/StyledButton";
import searchIcon from "../../assets/search.svg";
import ExpressWayIcon from "../../assets/expressway.png";
import NationalHighwayIcon from "../../assets/national-highway.png";
import StateHighwayIcon from "../../assets/state-highway.png";
import DistrictRoadsIcon from "../../assets/district-road.png";
import UrbanRoadsIcon from "../../assets/urban-road.png";
import RuralRoadsIcon from "../../assets/rural-road.png";
import PoiLayerIcon from "../../assets/poilayers.png";
import CNGLayerIcon from "../../assets/cng-svg.png";
import { AppContext } from "../../Context";
import {
  AddPOILayer,
  RemovePOILayer,
  AddRoadLayer,
  RemoveRoadLayer,
} from "./SideBarAPI";
import "./SideBar.css";
import _ from "lodash";

const POILayerOptions = [
  { name: "Hospitals", icon: "fa-solid fa-house-medical", color: "#BA274A" },
  { name: "Schools", icon: "fa-solid fa-school", color: "#3F0071" },
  { name: "Banks", icon:"bi bi-bank2", color: "#964B00" },
  { name: "Petrol pumps", icon: "bi bi-fuel-pump", color: "#171A1FFF" },
  { name: "CNG",  color:"#367E18",img:CNGLayerIcon },
  { name: "Industrial Centers", icon: "bi bi-hammer", color: "#3A86FF" },
  { name: "APMCS", icon: "fa-solid fa-building-wheat", color: "#E21818" },
  { name: "Transport Nagar", icon: "bi bi-truck-front", color: "#BF40BF" },
  { name: "Dealer", icon: "bi bi-geo-alt", color: "#BA274A" },
];//icon: "bi bi-device-ssd",
//    {'name':'Transport Nagar','icon':'bi bi-truck-front','color':'#0F9D58'}];
{/* <FontAwesomeIcon icon="fa-solid fa-school" style={{color: "#6e34a8",}} /> */}
{/* <FontAwesomeIcon icon="fa-solid fa-house-medical" /> */}

const RoadLayerOptions = [
  { name: "Expressways", img: ExpressWayIcon },
  { name: "National Highways", img: NationalHighwayIcon },
  { name: "State Highways", img: StateHighwayIcon },
  { name: "District Roads", img: DistrictRoadsIcon },
  { name: "Rural Roads", img: RuralRoadsIcon },
  { name: "Border Roads", img: UrbanRoadsIcon },
];

export default function SideBar(props) {
  const [layers, setLayers] = useState({});
  const [sideBarOption, setSideBarOption] = useState("poi");
  const { mapData, setMapData, stateData, setStateData, loader, setLoader } =
    useContext(AppContext);
  const poiElement = useRef();
  const roadElement = useRef();
  useEffect(() => {
    if (_.isEmpty(stateData.selected.District)) {
      poiElement.current.style.display = "none";
      roadElement.current.style.display = "none";
    } else {
      toggleDisplay(sideBarOption);
    }

    if (!_.isEmpty(layers) && !_.isEmpty(stateData.mapObject)) {
      let map = stateData.mapObject;
      Object.entries(layers).forEach((k, v) => {
        map.removeLayer(v);
      });
      setLayers({});
      setStateData({ ...stateData, mapObject: map });
    }

    // poiElement.current.style.display = "block";
    // roadElement.current.style.display = "none";
  }, [stateData.selected]);
  const callBack = (type, name, state) => {
    // console.log(type,name,state);

    if (type === "poi") {
      //    let POILayer = AddPOILayer(name,stateData,setStateData)
      //    setLayers({...layers,})
      state
        ? AddPOILayer(
            name,
            stateData,
            setStateData,
            layers,
            setLayers,
            loader,
            setLoader
          )
        : RemovePOILayer(
            name,
            stateData,
            setStateData,
            layers,
            setLayers,
            loader,
            setLoader
          );
    } else if (type === "road") {
      state
        ? AddRoadLayer(
            name,
            stateData,
            setStateData,
            layers,
            setLayers,
            loader,
            setLoader
          )
        : RemoveRoadLayer(
            name,
            stateData,
            setStateData,
            layers,
            setLayers,
            loader,
            setLoader
          );
    }
    // console.log("layers:",layers);
    // console.log(stateData.mapObject);
    //setPOILayer(mapData,stateData,setMapData);
  };
  //

  const POILayerOptionsComponents = POILayerOptions.map((item) => {
    return (
      <Row key={item.name}>
        <Col>
          <StyledButton
            styleCode={"poi"}
            text={item.name}
            icon={item?.icon}
            color={item.color}
            img={item?.img}
            callBack={item.name != "Dealer" ? callBack : null}
          />
        </Col>
      </Row>
    );
  });

  const RoadLayerOptionsComponents = RoadLayerOptions.map((item) => {
    return (
      <Row key={item.name}>
        <Col>
          <StyledButton
            styleCode={"road"}
            text={item.name}
            img={item.img}
            callBack={callBack}
          />
        </Col>
      </Row>
    );
  });

  function toggleDisplay(val) {
    if (val === "poi") {
      poiElement.current.style.display = "block";
      roadElement.current.style.display = "none";
    } else if (val === "road") {
      poiElement.current.style.display = "none";
      roadElement.current.style.display = "block";
    }
  }

  const [isActive, setActive] = useState(false);
  return (
    <>
      <div className={isActive ? "sidebar" : "sidebar close"}>
        {/* <div className="poi-heading-div">
            <h4 className="poiHeading">POI Layers</h4>
          </div> */}
        <div className="left-sidebar-section sidebar-item" ref={poiElement}>
          <div className="poi-heading-div">
            <div className="poiHeading">POI OPTIONS</div>
          </div>
          <div className="ctn">{POILayerOptionsComponents}</div>
        </div>

        <div className="left-sidebar-section sidebar-item" ref={roadElement}>
          <div className="poi-heading-div">
            <div className="poiHeading">ROAD OPTIONS</div>
          </div>
          {/* <div className="sidebar-pills">
            {_.isEmpty(stateData.selected.District) ? (
              <h6>
                POI and Road Network layer will work after selection of District
              </h6>
            ) : (
              // <div className='nav-selector'>
              <Nav
                  variant="pills"
                activeKey={sideBarOption}
                justify={true}
                onSelect={(val) => {
                  toggleDisplay(val);
                }}
                style={
                  _.isEmpty(stateData.selected.District)
                    ? { display: "none" }
                    : { display: "flex" }
                }
              >
                <Nav.Item>
                  <Nav.Link
                    eventKey="poi"
                    onClick={() => {
                      setSideBarOption("poi");
                    }}
                  >
                    POI
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="road"
                    onClick={() => {
                      setSideBarOption("road");
                    }}
                  >
                    Road
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              // </div>
            )}
            </div> */}
          <div className="ctn">{RoadLayerOptionsComponents}</div>
        </div>
        <div className="sidebar-pills sidebar-item">
          {_.isEmpty(stateData.selected.District) ? (
            <div className="sidebar-alt-text-div">
            <h6 className='sidebar-alt-text'>
              POI and Road Network layer will work after selection of District
            </h6>
            </div>
          ) : (
            <Nav
              // variant="pills"
              className='nav-sidebar'
              defaultActiveKey={"poi"}
              active={"poi"}
              justify={true}
              onSelect={(val) => {
                toggleDisplay(val);
              }}
              style={
                _.isEmpty(stateData.selected.District)
                  ? { display: "none" }
                  : { display: "flex" }
              }
            >
              <Nav.Item className="nav-sidebar-item">
                <Nav.Link className='nav-link-item' style={{color:'#fff'}} eventKey="poi">POI</Nav.Link>
              </Nav.Item>
              <Nav.Item className="nav-sidebar-item">
                <Nav.Link className='nav-link-item' style={{color:'#fff'}} eventKey="road">ROAD</Nav.Link>
              </Nav.Item>
            </Nav>
           )}
        </div>
      </div>
      <div
        className={isActive ? "slide-btn" : "slide-btn close"}
        // <div className="slide-btn"

        onClick={() => {
          setActive(!isActive);
        }}
      >
        {" "}
        <img src={PoiLayerIcon} alt="logo" className="p-1"></img>
        POI LAYERS
      </div>
    </>
  );
}

{
  /* <div className="sidebar-pills">
                    <Nav variant="pills" defaultActiveKey={"poi"} active={"poi"} justify={true} onSelect={(val)=>{toggleDisplay(val)}} style={_.isEmpty(stateData.selected.District) ? {"display" : "none"} : {"display" : "flex"}}>
                    <Nav.Item>
                        <Nav.Link eventKey="poi">POI</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="road">Road</Nav.Link>
                    </Nav.Item>
                    </Nav>
                </div> */
}
